// ADR-109 Rule RA-01 — شرط ۱: دکمه‌ای که فقط کارمند برای شروع درخواست دارد.
import { useState } from "react";
import { useRequestRemoteAssistSession } from "../api";
import type { RemoteAssistRequesterScope } from "../types";

interface RequestAssistButtonProps {
  supporterUserId?: string;
  vendorAgentId?: string;
  defaultScope?: RemoteAssistRequesterScope;
  onRequested?: (sessionId: string) => void;
}

export function RequestAssistButton({
  supporterUserId,
  vendorAgentId,
  defaultScope = "internal_org",
  onRequested,
}: RequestAssistButtonProps) {
  const { mutate, isPending, error } = useRequestRemoteAssistSession();
  const [justRequested, setJustRequested] = useState(false);

  const handleClick = () => {
    mutate(
      { requester_scope: defaultScope, supporter_user_id: supporterUserId, vendor_agent_id: vendorAgentId },
      {
        onSuccess: (session) => {
          setJustRequested(true);
          onRequested?.(session.id);
        },
      },
    );
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <button
        type="button"
        onClick={handleClick}
        disabled={isPending || justRequested}
        className="btn"
        style={{
          border: '1px solid var(--color-border)',
          backgroundColor: 'white',
          color: 'var(--color-text-main)',
          fontSize: '0.85rem'
        }}
      >
        {isPending ? "در حال ارسال درخواست..." : justRequested ? "درخواست ارسال شد" : "درخواست راهنمایی"}
      </button>
      {error && <p className="text-sm text-red-600">{(error as Error).message}</p>}
    </div>
  );
}
